<template>
  <div id="app" v-cloak>
    <headbar></headbar>
    <router-view v-slot="{ Component }">
      <keep-alive :include="keepAliveComponents">
        <component :is="Component" />
      </keep-alive>
    </router-view>
    <bottom-introduction></bottom-introduction>
  </div>
</template>

<script>
import headbar from './components/headbar'
import bottomIntroduction from './components/bottomIntroduction'

export default {
  created() {
  },
  name: 'app',
  data() {
    return {
      // 仅缓存 meta.keepAlive 为 true 的路由组件(按组件 name 匹配)
      // 对应 router.js 中 keepAlive:true 的 5 个路由
      keepAliveComponents: ['indexTrade', 'IndexProduct', 'Estate', 'SingelProduct', 'pIndexHome']
    }
  },
  mounted() {
  },
  methods: {},
  components: {
    headbar,
    bottomIntroduction
  }
}
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
}
#app{
  overflow: hidden;
}
[v-cloak]{
  display: none;
}

::-webkit-scrollbar {
  width: 0 !important;
}
</style>
